import { tick } from "svelte";

/**
 *
 *
 *
 *
 *
 *
 */
export const unmaskLightDomElement = (
  decodedHref: string,
  ev: Event | undefined,
  lightDomElement: HTMLElement,
): void => {
  if (lightDomElement instanceof HTMLAnchorElement) {
    lightDomElement.href = decodedHref;
  } else {
    /*                                                     */
    /*                                                                                                 */
    const anchorElement = document.createElement("a");

    /*                                                          */
    Array.from(lightDomElement.attributes).forEach(({ name, value }) =>
      anchorElement.setAttribute(name, value),
    );

    anchorElement.href = decodedHref;

    /*                                                           */
    anchorElement.append(...lightDomElement.childNodes);

    /*                                           */
    lightDomElement.parentNode?.replaceChild(anchorElement, lightDomElement);

    /*                                                */
    if (ev instanceof FocusEvent && lightDomElement === ev.target) {
      ev.preventDefault(); /*                                 */
      ev.stopPropagation(); /*                                                              */
      /*                    */
      /*                                                     */
      anchorElement.focus();
    }
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const unmaskThisElement = async (
  decodedHref: string,
  ev: Event | undefined,
  setHref: (href: string | undefined) => void,
  getThisElement: () => HTMLElement | null | undefined,
): Promise<void> => {
  /*                                                      */
  setHref(decodedHref);

  /*                                  */
  if (ev instanceof FocusEvent) {
    /*                                     */
    await tick();

    /*                    */
    /*                                                     */
    getThisElement()?.focus();
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useUnmaskHref =
  (
    getBase64Href: () => string | undefined,
    getLightDomElement: () => HTMLElement | null | undefined,
    getThisElement: () => HTMLElement | null | undefined,
    unsetBase64Href: () => void,
    setHref: (href: string | undefined) => void,
  ) =>
  async (ev: Event | undefined): Promise<void> => {
    const base64Href = getBase64Href();
    if (!base64Href) return;

    const decodedHref = atob(base64Href);
    unsetBase64Href();

    const lightDomElement = getLightDomElement();
    if (lightDomElement) return unmaskLightDomElement(decodedHref, ev, lightDomElement);

    /*                                                         */
    return unmaskThisElement(decodedHref, ev, setHref, getThisElement);
  };
